import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface FormData {
    [key: string]: string | number | boolean;
}

export interface MarketoFormData {
    marketoFormId: string;
    formData: FormData;
}

export interface SewMailFormData {
    [key: string]: string | number | boolean | FormData;
    formData: FormData;
}

@Injectable({
    providedIn: 'root',
})
export class WebformsService {
    public constructor(private http: HttpClient) {}

    public subscribeWithMarketo(formData: MarketoFormData) {
        return this.http.post('/servlet/marketo', formData);
    }

    public subscribeWithSewMail(formData: SewMailFormData) {
        return this.http.post('/servlet/mail', formData, { withCredentials: true });
    }
}
